<template>
    <div class="mb-3">
        <div class="bg-gray2 pb-1">
            <div class="container-fluid">
                <div class="d-flex justify-content-between align-items-end">
                    <!--/* Zone Fil d'ariane */-->
                    <ob1-breadcrumb :items="breadcrumbItems" style="min-width: 0" class="me-2 breadcrumb-full" />
                    <!--/* bandeau lien et icône panier */-->
                    <cart-banner
                        class="py-1"
                        :cart-link="cartUrl"
                        :number-of-items="accessoriesInCartCount"
                        :cart-enabled="!!cartUrl"
                    />
                </div>

                <div class="d-flex flex-column flex-md-row mb-1 header">
                    <!--/* banner - brand et le nom de l'accessoire  */-->
                    <h1 class="mb-0 me-md-1">
                        <span
                            v-if="bannerAndBrand"
                            class="h3 fw-normal"
                        >
                            {{ bannerAndBrand }}</span>
                        <br>
                        <strong>{{ currentVersion.name }}</strong>
                    </h1>


                    <!--/* rating-summary */-->
                    <Rating
                        v-if="displayRatings"
                        class="item-summary align-items-end mb-md-1 m-0"
                        :average="currentVersion.reviewsStats.average"
                        :text="'('+currentVersion.reviewsStats.count+' avis)'"
                        :rating-results-height="1.375"
                        link="#anchor-reviews"
                        @ob1-rating-link.prevent="scrollToPageMenuAnchor('anchor-reviews')"
                    />
                </div>
                <div class="d-flex flex-column flex-md-row bg-white">
                    <!--/* img */-->
                    <div class="d-flex flex-column info-device-width border-right-md border-gray2">
                        <div class="px-1 px-lg-2 py-1">
                            <div class="item-img">
                                <ob1-carrousel
                                    :id="'device-gallery'"
                                    :key="'device-gallery-' + currentVersion.seoId"
                                    :images="currentVersion.images"
                                    :is-product-sheet="true"
                                    :is-device-product-sheet="true"
                                    :with-zoom="true"
                                    :with-thumbnails="true"
                                />
                            </div>
                            <ob1-separateur v-if="currentVersion.asilage" class="my-1" />
                            <asilage
                                v-if="currentVersion.asilage"
                                :title="currentVersion.asilage.title"
                                :condition="currentVersion.asilage.condition"
                                :form-url="currentVersion.asilage.formUrl"
                                :image="currentVersion.asilage.image"
                                :condition-label="currentVersion.asilage.conditionLabel"
                            />
                        </div>
                    </div>
                    <div class="w-100">
                        <div class="px-1 px-md-2 py-1">
                            <fieldset>
                                <legend class="visually-hidden">
                                    Couleur
                                </legend>
                                <ColorChips
                                    :id="'colors'"
                                    class="mb-1"
                                    :selected-color="currentVersion.color ? currentVersion.color.code : null"
                                    :colors="allColors"
                                    @change="changeVariant('color', $event.code)"
                                />
                            </fieldset>

                            <fieldset
                                v-for="(variant, index) in dto.allVariants"
                                :key="index"
                                :class="numberOfColors > 0 ? 'mb-1' : 'mt-1 mb-1'"
                            >
                                <legend class="visually-hidden">
                                    {{ variant.name }}
                                </legend>
                                <ob1-chips
                                    v-for="(value, valueIndex) in variant.values"
                                    :id="'variant-' + index + '-' + valueIndex"
                                    :key="'variant-' + index + '-' + valueIndex"
                                    :is-choice-version="true"
                                    :label="value"
                                    :is-disabled="index === dto.allVariants.length - 1 && !hasVariantEnabled(variant.name, value)"
                                    :is-checked="hasCurrentVersionVariantChecked(variant.name, value)"
                                    :disable-uncheck="true"
                                    @ob1-chips-click="changeVariant(variant.name, value)"
                                />
                            </fieldset>

                            <fieldset v-if="allGrades.length > 0" class="mt-1">
                                <legend class="visually-hidden">
                                    Etat du mobile Reconditionné
                                </legend>
                                <ob1-chips
                                    v-for="(grade, index) in allGrades"
                                    :id="'grade-' + index"
                                    :key="'grade-' + index"
                                    :is-choice-version="true"
                                    :label="grade.label"
                                    :is-disabled="false"
                                    :is-checked="grade.isChecked"
                                    additional-classes="mb-1"
                                    :disable-uncheck="true"
                                    @ob1-chips-click="changeVariant('grade', grade.label)"
                                />
                            </fieldset>

                            <template v-if="allGrades.length > 0">
                                <ob1-liens
                                    text="Pour en savoir plus, c'est par ici"
                                    is-button
                                    data-bs-toggle="modal"
                                    modal-id="gradeModal"
                                    with-arrow
                                    data-oevent-category="comment_choisir_son_reconditionne"
                                    :data-oevent-action="getGradePopinAction()"
                                    data-oevent-label="vers_popin"
                                />
                                <grade-popin
                                    :modal-id="'gradeModal'"
                                    :default-grade-id="checkedGrade?.code"
                                    :labels="gradeLabels"
                                />
                            </template>

                            <fieldset v-if="allBatteries.length > 0" class="mt-1">
                                <legend class="visually-hidden">
                                    Etat de la batterie
                                </legend>
                                <ob1-chips
                                    v-for="(battery, index) in allBatteries"
                                    :id="'battery-' + index"
                                    :key="'battery-' + index"
                                    :is-choice-version="true"
                                    :label="battery.label"
                                    :is-disabled="!hasVariantEnabled('battery', battery.label)"
                                    :is-checked="battery.isChecked"
                                    additional-classes="mb-1"
                                    :disable-uncheck="true"
                                    @ob1-chips-click="changeVariant('battery', battery.label)"
                                />
                            </fieldset>

                            <ob1-separateur class="my-1" />

                            <div class="d-lg-flex justify-content-between">
                                <device-detail-price
                                    :device-price="currentVersion.price"
                                    :is-price-inversion-enabled="dto.priceInversionEnabled"
                                    :loan-rate-zero-label="dto.loanRateZeroLabel"
                                    :loan-rate-zero-offer-label="dto.loanRateZeroOfferLabel"
                                    :funding-details="fundingDetails"
                                    :show-guarantee-legal-mentions="currentVersion.showGuaranteeLegalMentions"
                                    :guarantee-legal-mentions-label="currentVersion.guaranteeLegalMentionsLabel"
                                    :advantage-messages="dto.advantageMessages"
                                    :pxf-legal-mentions-text="shouldDisplayPXFMention ? dto.pxfMention : null"
                                />
                            </div>

                            <refunds
                                v-if="currentVersion.advantages"
                                class="mb-1"
                                :odrs="currentVersion.advantages.odrData"
                                :device-seo-id="currentVersion.seoId"
                                :refund-messages="dto.refundMessages"
                                :total-amount-in-cents="currentVersion.advantages.totalAmountInCents"
                                :advantages-label="currentVersion.advantages.label"
                                :recovery="currentVersion.advantages.recovery"
                                :simulator-modal-id="simulatorModalId"
                                :simulator-result-modal-id="savedSimulationResultModalId"
                                :recovery-modal-id="recoveryModalId"
                            />
                            <template v-if="hasRecovery">
                                <mobile-recovery-simulator-modal
                                    :modal-id="simulatorModalId"
                                    :shop="dto.shop"
                                    :messages="dto.refundMessages.recoverySimulator"
                                    @update-recovery-simulation="updateRecoveryPrice"
                                />
                                <mobile-recovery-simulation-result-modal
                                    v-if="currentVersion.advantages.recovery.manualEstimation"
                                    :modal-id="savedSimulationResultModalId"
                                    :shop="dto.shop"
                                    :messages="dto.refundMessages.recoverySimulator.result"
                                    :estimated-device-price-in-cents="currentVersion.advantages.recovery.amountInCents"
                                    :estimated-device-model="currentVersion.advantages.recovery.deviceModel"
                                    :bonus="currentVersion.advantages.recovery.bonus"
                                    :online-recovery-available="onlineRecoveryAvailable"
                                    @new-simulation="newSimulation"
                                    @save-simulation="saveSimulation"
                                />
                                <mobile-recovery-simulation-result-modal
                                    :modal-id="currentSimulationResultModalId"
                                    :shop="dto.shop"
                                    :messages="dto.refundMessages.recoverySimulator.result"
                                    :estimated-device-price-in-cents="estimatedDevice.recoveryPriceInCents"
                                    :estimated-device-model="estimatedDevice.model"
                                    :bonus="currentVersion.advantages.recovery.bonus"
                                    :online-recovery-available="onlineRecoveryAvailable"
                                    @new-simulation="newSimulation"
                                    @save-simulation="saveSimulation"
                                />
                                <mobile-recovery-details-modal
                                    :modal-id="recoveryModalId"
                                    :infos-recovery="dto.refundMessages.recoveryModal.infosRecovery"
                                    :online-recovery="onlineRecoveryAvailable ? dto.refundMessages.recoveryModal.onlineRecovery: null"
                                    :store-recovery="eligibleEresa ? dto.refundMessages.recoveryModal.storeRecovery : null"
                                    :bonus-recovery="dto.refundMessages.recoveryModal.bonusRecovery"
                                    :bonus="currentVersion.advantages.recovery.bonus"
                                    :recovery-simulator="dto.refundMessages.recoverySimulator"
                                    :simulator-button-label="dto.refundMessages.simulatorButtonLabel"
                                    :bonus-amount="bonusAmountFormat"
                                    :simulator-modal-id="simulatorModalId"
                                />
                            </template>

                            <template
                                v-if="currentVersion.inStock"
                            >
                                <div v-if="isLoading" class="item-spinner d-flex justify-content-center">
                                    <ob1-progress-indicators :size="50" type="undetermined" />
                                </div>
                                <ob1-boutons
                                    v-else
                                    ref="add-device-cta"
                                    class="mt-1"
                                    label="Ajouter au panier"
                                    :is-primary="true"
                                    @ob1-boutons-click="onAddToCart"
                                />
                            </template>
                            <div
                                v-else
                                class="row"
                            >
                                <ob1-message-alerte
                                    class="col-12 pt-2"
                                    :is-simple-alerte="false"
                                    :title="dto.alertStatusMessages.title"
                                    :text="dto.alertStatusMessages.message"
                                    type="warning"
                                />
                            </div>
                            <div class="mt-2">
                                <sold-by-card
                                    :title="sellerLabel"
                                    :sold-by-orange="currentVersion.firstParty"
                                    :info-lines="deliveryLabels"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--/* DAS / Batterie / Energy-Label */-->
        <div v-if="shouldShowDasBatteryOrEnergyLabelBlock" class="bg-gray2">
            <div class="container-fluid">
                <div class="row align-items-center pb-1">
                    <!--/* DAS */-->
                    <div v-if="currentVersion.das" class="col-12 col-md-auto">
                        <das
                            class="my-1"
                            :head="currentVersion.das.head"
                            :trunk="currentVersion.das.trunk"
                            :member="currentVersion.das.member"
                            :prefix="currentVersion.das.prefix"
                            :popin-title="currentVersion.das.popinTitle"
                            :popin-text="currentVersion.das.popinDescription"
                        />
                    </div>
                    <!--/* Batterie(Charger) */-->
                    <template v-if="currentVersion.chargerInfos">
                        <div v-if="currentVersion.chargerInfos.chargerIncluded" class="col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0">
                            <div class="d-flex align-items-center">
                                <div class="icon icon-charger-availability charger-icon-size ps-1 ps-md-0 text-gray4" aria-hidden="true" />
                                <strong class="ps-3 ps-md-0" v-html="currentVersion.chargerInfos.chargerIncludedMessage" />
                            </div>
                        </div>
                        <div v-else-if="currentVersion.chargerInfos.chargerCompatibleInfos" class="col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0">
                            <ChargerInfos :charger-infos="currentVersion.chargerInfos.chargerCompatibleInfos" />
                        </div>
                    </template>
                    <!--/* Energy-Label */-->
                    <div v-if="currentVersion.energyLabel" class="col-12 col-md-auto">
                        <energy-label :id="currentVersion.seoId" :energy-label="currentVersion.energyLabel" />
                    </div>
                </div>
            </div>
        </div>


        <!--/* Financing */-->
        <section v-if="shouldDisplayPXFMention" class="container-fluid">
            <div class="row mt-2 mb-1">
                <div class="col-12">
                    <financing-mentions :financing-mentions="dto.financingMentions" />
                </div>
            </div>
            <ob1-separateur
                v-if="crossSellAccessories.length === 0"
                class="my-2 mb-1"
            />
        </section>


        <div v-if="loadingCrossSell" :class="['bg-gray2', shouldShowDasBatteryOrEnergyLabelBlock ? 'py-1' : 'py-2']">
            <div class="d-flex justify-content-center">
                <ob1-progress-indicators :size="50" type="undetermined" class="my-auto" />
            </div>
        </div>
        <div
            v-if="crossSellAccessories.length > 0"
            :class="['bg-gray2', shouldShowDasBatteryOrEnergyLabelBlock ? 'py-1' : 'py-2']"
        >
            <section class="container-fluid bg-white py-1">
                <div class="row">
                    <div class="col-12">
                        <h2>Accessoirement, vous n'oubliez rien ?</h2>
                    </div>
                </div>
                <CrossSellAccessories
                    :accessory-ctrl="marketplaceCtrl"
                    :compact-promo-messages-dto="dto.compactPromoMessages"
                    :advantage-messages="dto.advantageMessages"
                    :das-dto="dto.dasLabel"
                    :accessories="crossSellAccessories"
                    seller-shop-name="Orange"
                    @accessory-updated="onCrossSellUpdated"
                    @accessory-error="onCrossSellError"
                />
            </section>
        </div>

        <div class="container-fluid mt-2">
            <p v-if="currentVersion.descriptionTitle" class="lead text-mw mb-0">
                <strong>{{ currentVersion.descriptionTitle }}</strong>
            </p>
            <p v-if="currentVersion.description" class="text-mw" v-html="currentVersion.description" />

            <!--/* Page Menu */-->
            <ob1-page-menu
                v-if="pageMenu.tabs.length > 0"
                id="device-details-page-menu"
                :tabs="tabs"
                class="sticky bg-white mb-2"
                @ob1-page-menu-click="scrollToPageMenuAnchor"
            />

            <!--/* Zigzag */-->
            <section v-if="currentVersion.zigZag || currentVersion.longDescription">
                <div class="mb-xl-3" />
                <header-signature :text="essentialTitle" />
                <EditorialPush v-if="currentVersion.zigZag" :zigzag="currentVersion.zigZag" :with-image-resize="!currentVersion.firstParty" />
                <div v-else-if="currentVersion.longDescription">
                    <p id="anchor-zig-zag" v-html="currentVersion.longDescription" />
                </div>
            </section>

            <!--/* Fiche Technique */-->
            <section v-if="currentVersion.technicalFeatures">
                <ob1-separateur v-if="currentVersion.zigZag || currentVersion.longDescription" class="my-2 mb-xl-3" />
                <accessory-technical-features
                    :is-first-party="currentVersion.firstParty"
                    :accessory-features="currentVersion.technicalFeatures"
                />
            </section>

            <!--/* La Reprise */-->
            <template v-if="hasRecovery">
                <section class="mb-2 mb-md-3">
                    <ob1-separateur class="my-2" />
                    <header-signature :text="dto.recoveryMessages.messages.title" />
                    <mobile-recovery
                        id="anchor-mobile-recovery"
                        :recovery-amount-in-cents="currentVersion.advantages.recovery.amountInCents"
                        :recovery-device-model="currentVersion.advantages.recovery.deviceModel"
                        :manual-estimation="currentVersion.advantages.recovery.manualEstimation"
                        :bonus-amount-in-cents="bonusAmountInCents"
                        :simulator-modal-id="simulatorModalId"
                        :recovery-modal-id="recoveryModalId"
                        :messages="dto.recoveryMessages.messages"
                        :visual="dto.recoveryMessages.visual"
                        :shop="dto.shop"
                    />
                </section>
            </template>

            <!--/* Les garanties légales */-->
            <section v-if="currentVersion.showGuaranteeLegalMentions">
                <ob1-separateur class="my-2 mb-xl-3" />
                <guarantee-legal-mentions :legal-mentions="currentVersion.deviceLegalMentions" />
            </section>

            <!--/* Avis clients */-->
            <template v-if="displayRatings">
                <section class="mb-md-3">
                    <ob1-separateur v-if="currentVersion.showGuaranteeLegalMentions" class="my-2" />
                    <header-signature :text="reviewsMessages.title" />
                    <device-average-rating-reviews
                        :reviews-stats-average="currentVersion.reviewsStats.average"
                        :review-count="currentVersion.reviewsStats.count"
                        :reviews-messages="reviewsMessages"
                        :summary="currentVersion.summary"
                    />
                    <device-filter-and-details-reviews
                        :device-details-reviews="deviceDetailsReviews"
                        :total-review-count="currentVersion.reviewsStats.count"
                        :device-filter-reviews="deviceFilterReviews"
                        :reviews-messages="reviewsMessages"
                        :ratings-filter-checkboxes="ratingsFilterCheckboxes"
                        :date-sort-radio-buttons="dateSortRadioButtons"
                        @update-ratings-filter-handler="updateRatingsFilterHandler"
                        @review-date-sort-item-click="reviewDateSortHandler"
                        @more-device-reviews="getMoreDeviceReviews"
                    />
                </section>
            </template>

            <!--/* Zone environmental */-->
            <ob1-liens
                v-if="currentVersion.environmentalQuality"
                class="mw-100 py-0"
                :href="currentVersion.environmentalQuality.url"
                :text="currentVersion.environmentalQuality.linkLabel"
                :with-arrow="true"
                :is-mini="true"
                target="_blank"
            />
        </div>
        <div
            v-if="currentVersion.price.price.paymentInfoLabel && currentVersion.price.price.paymentInfoLabel.type === 'CB4X'"
            class="bg-gray2 mt-1 pt-1 pb-1"
        >
            <div class="container-fluid">
                <legal-mentions4x-cb
                    :label="dto.cb4xMention.label"
                    :popin4x-cb="dto.cb4xMention.cb4xPopin"
                    :pxf-legal-mentions-text="dto.pxfMention"
                />
            </div>
        </div>

        <ob1-snack-bar
            id="snackbar"
            ref="snackbar"
            icon="icon-error-severe"
            :label="errorMessage"
        />
        <ob1-popin-modal2
            :id="'add-to-cart-popin'"
            :aria-labelledby="'add-to-cart-popin-label'"
            :show-close-button="false"
        >
            <AlertMessage
                id="add-to-cart-popin-label"
                :title="dto.cartMessages.addSuccess"
                type="success"
            />
            <AlertMessage
                v-if="cartPaymentChange"
                :title="dto.cartMessages.paymentChangeTitle"
                :text="dto.cartMessages.paymentChangeText"
                type="info"
            />
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column">
                    <ob1-boutons
                        data-bs-dismiss="modal"
                        :label="'Continuer vos achats'"
                        :is-secondary="true"
                        class="my-2"
                    />

                    <ob1-boutons
                        :label="'Voir votre panier'"
                        :href="cartUrl"
                        :is-button="false"
                        :is-primary="true"
                    />
                </div>
            </div>
        </ob1-popin-modal2>
        <!-- snack bar pour afficher le message de confirmation d'enregistrement de la simulation de reprise -->
        <ob1-snack-bar
            id="simulation-snackbar"
            ref="savedSimulationSnackbar"
            icon="icon-tick-circle"
            :label="dto.refundMessages.recoverySimulator.result.snackbarLabel"
        />
    </div>
</template>

<script>

import {VersionSorter} from "../common/mixins/VersionSorter";
import {ColorSorter} from "../common/mixins/ColorSorter";
import AccessoryTechnicalFeatures from "../accessories/AccessoryTechnicalFeatures.vue";
import Asilage from "../common/components/Asilage.vue";
import AvailabilityMention from "../common/mobiledetails/AvailabilityMention.vue";
import CrossSellAccessories from "../common/components/CrossSellAccessories.vue";
import DeviceDetailPrice from "./components/DeviceDetailPrice.vue";
import {MarketplaceCtrl} from "./MarketplaceCtrl";
import CartBanner from "../common/CartBanner.vue";
import Refunds from "../common/components/Refunds.vue";
import DeviceFilterAndDetailsReviews from "../common/devicereviews/DeviceFilterAndDetailsReviews.vue";
import HeaderSignature from "../../common/components/vue/HeaderSignature.vue";
import DeviceAverageRatingReviews from "../common/devicereviews/DeviceAverageRatingReviews.vue";
import {scrollToElement} from "../common/Util";
import LegalMentions4xCb from "../common/components/LegalMentions4xCb.vue";
import FinancingMentions from "../common/components/FinancingMentions.vue";
import AlertMessage from "../../common/components/ob1/AlertMessage.vue";
import GuaranteeLegalMentions from "../common/components/GuaranteeLegalMentions.vue";
import ChargerInfos from "../common/ChargerInfos.vue";
import ColorChips from "../../common/components/ob1/ColorChips.vue";
import EnergyLabel from "../common/EnergyLabel.vue";
import Das from "../common/components/Das.vue";
import SoldByCard from "../../common/components/custom/SoldByCard.vue";
import EditorialPush from "../../common/components/ob1/EditorialPush.vue";
import Rating from "../../common/components/ob1/Rating.vue";
import GradePopin from "../common/components/GradePopin.vue";
import {toTmsFormat} from "../../common/utils/TmsUtils";
import MobileRecoveryDetailsModal from "../common/MobileRecoveryDetailsModal.vue";
import MobileRecoverySimulationResultModal from "../common/MobileRecoverySimulationResultModal.vue";
import MobileRecoverySimulatorModal from "../common/MobileRecoverySimulatorModal.vue";
import MobileRecovery from "../common/mobilerecovery/MobileRecovery.vue";

const dto = JSON.parse(document.getElementById("device-details").dataset.deviceDetails);

const DeviceAddedState = Object.freeze({
    LOADED: 1,
    LOADING: 2,
})

export default {
    name: "DeviceDetails",
    components: {
        MobileRecovery,
        MobileRecoverySimulatorModal,
        MobileRecoverySimulationResultModal,
        MobileRecoveryDetailsModal,
        GradePopin,
        Rating,
        EditorialPush,
        SoldByCard,
        ColorChips,
        Das, EnergyLabel, ChargerInfos,
        AccessoryTechnicalFeatures,
        AlertMessage,
        FinancingMentions,
        LegalMentions4xCb,
        Refunds,
        DeviceAverageRatingReviews,
        HeaderSignature,
        DeviceFilterAndDetailsReviews,
        CrossSellAccessories,
        CartBanner,
        Asilage,
        DeviceDetailPrice,
        GuaranteeLegalMentions
    },
    mixins: [ColorSorter, VersionSorter],
    data() {
        return {
            dto: dto,
            currentVersion: dto.currentVersion,
            allVersions: dto.allVersions,
            versionsCapacities: dto.allCapacities,
            fundingDetails: dto.fundingDetails,
            breadcrumbItems: dto.filAriane.items,
            crossSellAccessories: [],
            marketplaceCtrl: undefined,
            loadingCrossSell: false,
            errorMessage: "",
            essentialTitle: dto.essentialTitle,
            pageMenu: dto.pageMenu,
            reviewsMessages: dto.reviewsMessages,
            reviewDateSortParam: dto.reviewDateSort ?? "date-desc",
            deviceDetailsReviews: {
                cursor: undefined,
                reviews: [],
                loading: true
            },
            deviceFilterReviews: {
                ratingsFilter: [],
                loading: true
            },
            selectedRatingsFilter: [],
            state: DeviceAddedState.LOADED,
            cartUrl: dto.cart?.url,
            accessoriesInCartCount: dto.cart?.numberOfItems,
            paymentCbOrPxfInCart: dto.cart?.hasCb4xOrPxfPayment,
            cartPaymentChange: false,
            gradeLabels: dto.gradeLabels,
            departments: dto.departments,
            estimatedDevice: {
                recoveryPriceInCents: undefined,
                model: undefined
            },
            simulatorModalId: "mobile-recovery-simulator",
            currentSimulationResultModalId: "current-mobile-recovery-simulation-result",
            savedSimulationResultModalId: "saved-mobile-recovery-simulation-result",
            recoveryModalId: "mobile-recovery-popin"
        };
    },
    computed: {
        allColors: function () {
            const colors = [];
            for (const version of this.allVersions) {
                const versionColor = version.color;
                if (versionColor && !colors.find(color => color.code === versionColor.code)) {
                    colors.push(
                        {
                            colorName: versionColor.colorName,
                            code: versionColor.code,
                            isChecked: this.checkedColor && this.checkedColor.code === versionColor.code
                        }
                    );
                }
            }
            return this.sortColors(colors);
        },
        allGrades: function () {
            const grades = [];
            for (const version of this.allVersions) {
                const versionGrade = version.grade;
                if (versionGrade && !grades.find(grade => grade.label === versionGrade.label)) {
                    grades.push(
                        {
                            label: versionGrade.label,
                            isChecked: this.checkedGrade && this.checkedGrade.label === versionGrade.label,
                            sortOrder: versionGrade.sortOrder
                        }
                    );
                }
            }
            return grades.sort((a, b) => a.sortOrder - b.sortOrder);
        },
        allBatteries: function () {
            const batteries = [];
            for (const version of this.allVersions) {
                const versionBattery = version.battery;
                if (versionBattery && !batteries.find(battery => battery.label === versionBattery.label)) {
                    batteries.push(
                        {
                            label: versionBattery.label,
                            isChecked: this.checkedBattery && this.checkedBattery.label === versionBattery.label,
                            sortOrder: versionBattery.sortOrder
                        }
                    );
                }
            }
            return batteries.sort((a, b) => a.sortOrder - b.sortOrder);
        },
        checkedColor: function () {
            return this.currentVersion.color;
        },
        checkedGrade: function () {
            return this.currentVersion.grade;
        },
        checkedBattery: function () {
            return this.currentVersion.battery;
        },
        displayRatings() {
            return !!this.currentVersion.reviewsStats;
        },
        numberOfColors: function () {
            return this.allVersions.filter(version => version.color !== undefined).length;
        },
        pageMenuOffsetHeight: function () {
            if (document.querySelector('#device-details-page-menu')) {
                return document.querySelector('#device-details-page-menu').offsetHeight;
            }
            return 0;
        },
        ratingsFilterCheckboxes() {
            return this.deviceFilterReviews.ratingsFilter.map(rating => {
                return {
                    label: rating.label,
                    isChecked: this.selectedRatingsFilter.includes(rating.id),
                    count: rating.count,
                    id: rating.id,
                }
            })
        },
        sellerLabel() {
            return this.currentVersion.seller.url
                ? `Vendu et expédié par <b><a href="${this.currentVersion.seller.url}" target="_blank">${this.currentVersion.seller.name}</a></b>`
                : `Vendu et expédié par <b>${this.currentVersion.seller.name}</b>`
        },
        deliveryLabels() {
            return this.currentVersion.deliveryMessages;
        },
        shouldDisplayPXFMention() {
            return this.currentVersion.price.price.paymentInfoLabel && this.currentVersion.price.price.paymentInfoLabel.type === 'PXF';
        },
        tabs() {
            const hiddenTabs = ['anchor-eco-rating', 'anchor-reconditioned'];
            if (!this.currentVersion.zigZag && !this.currentVersion.longDescription) {
                hiddenTabs.push('anchor-zig-zag');
            }
            if (!this.currentVersion.technicalFeatures) {
                hiddenTabs.push('anchor-technical-sheet');
            }
            if (!this.currentVersion.showGuaranteeLegalMentions) {
                hiddenTabs.push('anchor-guarantee-legal-mentions');
            }
            if (!this.currentVersion.reviewsStats) {
                hiddenTabs.push('anchor-reviews');
            }
            if (!this.hasRecovery) {
                hiddenTabs.push('anchor-mobile-recovery');
            }
            return this.pageMenu.tabs.filter(tab => !hiddenTabs.includes(tab.id));
        },
        isLoading() {
            return this.state === DeviceAddedState.LOADING;
        },
        shouldShowDasBatteryOrEnergyLabelBlock() {
            return this.currentVersion?.chargerInfos || this.currentVersion?.energyLabel || this.currentVersion?.das;
        },
        dateSortRadioButtons() {
            const sortOptions = [
                { id: "date-asc", value: "date-asc", ariaLabelledBy: "date-croissante", primaryText: this.reviewsMessages.sortAscending },
                { id: "date-desc", value: "date-desc", ariaLabelledBy: "date-decroissante", primaryText: this.reviewsMessages.sortDescending }
            ];

            return sortOptions.map(option => ({
                radioButtonDTO: {
                    id: option.id,
                    name: "tri",
                    label: "",
                    checked: this.reviewDateSortParam === option.id,
                    ariaLabelledBy: option.ariaLabelledBy,
                    value: option.value
                },
                primaryText: option.primaryText
            }));
        },
        bannerAndBrand() {
            if (this.currentVersion?.price?.banner && this.currentVersion?.brand) {
                return `${this.currentVersion?.price?.banner} - ${this.currentVersion?.brand.toUpperCase()}`;
            } else if (this.currentVersion?.price?.banner) {
                return `${this.currentVersion?.price?.banner}`;
            } else if (this.currentVersion?.brand) {
                return `${this.currentVersion?.brand.toUpperCase()}`;
            }
            return '';
        },
        hasRecovery() {
            return this.currentVersion?.advantages?.recovery != null;
        },
        bonusAmountFormat() {
            let amountInCents = this.bonusAmountInCents;
            if (amountInCents) {
                return PriceFormatter.formatEurosWithSpace(amountInCents / 100, false).toString();
            } else {
                return null;
            }
        },
        bonusAmountInCents() {
            return this.currentVersion?.advantages?.recovery?.bonus?.amountInCents;
        },
        eligibleEresa() {
            return this.currentVersion?.eligibleEresa ?? false;
        },
        onlineRecoveryAvailable() {
            return this.currentVersion?.onlineRecoveryAvailable ?? false;
        },
    },
    created: function () {
        document.addEventListener('scroll', () => {
            if (this.tabs && this.tabs.length > 0) {
                updatePageMenu('device-details-page-menu', this.tabs.map(tab => "#" + tab.id));
            }
        });
    },
    mounted() {
        this.marketplaceCtrl = new MarketplaceCtrl(
            {
                orderId: dto.cart?.orderId,
                shop: dto.shop
            }
        )
        if (this.currentVersion.firstParty) {
            this.loadCrossSell().then(accessories => {
                this.crossSellAccessories = accessories.other
            }).finally(() => {
                this.loadDeviceReviews();
            })
        } else {
            this.loadDeviceReviews()
        }
        this.updateBreadcrumbFromReferrer()
    },
    methods: {
        hasCurrentVersionVariantChecked(name, value) {
            return this.currentVersion.variants.some(variant => variant.name === name && variant.value === value);
        },
        findVersionByVariants(variants) {
            return this.allVersions.find(version =>
                variants.every(variant =>
                    version.variants.some(v => v.name === variant.name && v.value === variant.value)
                )
            );
        },
        findVersionByVariant(name, value) {
            return this.allVersions.find(version =>
                version.variants.some(v => v.name === name && v.value === value)
            );
        },
        hasVariantEnabled(name, value) {
            let currentVariants = this.currentVersion.variants;
            let newVariants = currentVariants.map(variant =>
                variant.name === name ? { ...variant, value: value }
                    : variant
            );
            if (!newVariants.some(variant => variant.name === name)) {
                newVariants.push({name: name, value: value});
            }
            return this.findVersionByVariants(newVariants);
        },
        changeVariant(variantName, variantValue) {
            let currentVariants = this.currentVersion.variants;
            let newVariants = currentVariants.map(variant =>
                variant.name === variantName ? { ...variant, value: variantValue }
                    : variant
            );
            let newVersion = this.findVersionByVariants(newVariants);
            if (newVersion) this.currentVersion = newVersion;
            else this.currentVersion = this.findVersionByVariant(variantName, variantValue);
            this.updateInfos();
        },
        updateInfos() {
            // On met à jour l'url
            this.updateUrl();
            // On met à jour le fil d'ariane
            this.updateBreadcrumb();
        },
        updateBreadcrumb() {
            const breadcrumbLength = this.breadcrumbItems.length
            this.breadcrumbItems.splice(breadcrumbLength - 1, 1, {name: this.currentVersion.name})
        },
        updateUrl() {
            // On met à jour l'url avec le seoId de la déclinaison sélectionnée
            const slug = window.location.href.substring(
                window.location.href.lastIndexOf("/") + 1
            );
            const parameterIndex = window.location.href.lastIndexOf("?");
            const parameters = parameterIndex === -1 ? "" : window.location.href.substring(parameterIndex);
            const fullUrlWithoutSlug = window.location.href.substring(
                0, window.location.href.lastIndexOf(slug)
            );
            const updatedUrl = fullUrlWithoutSlug + this.currentVersion.seoId + parameters;
            window.history.replaceState({}, null, updatedUrl);
        },
        updateUrlWithReviewsSort() {
            if (this.reviewDateSortParam != null && this.reviewDateSortParam !== "") {
                return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "reviewSort", this.reviewDateSortParam))
            }
        },
        onAddToCart() {
            this.state = DeviceAddedState.LOADING
            this.marketplaceCtrl.addAccessory(this.currentVersion.seoId, this.currentVersion.offerId)
                .then((result) => {
                    this.state = DeviceAddedState.LOADED;
                    this.accessoriesInCartCount = this.getAccessoriesInCart(result.cartInfo);
                    this.cartUrl = result.cartUrl;
                    let paymentCbOrPxfInCartBeforeAdd = this.paymentCbOrPxfInCart;
                    let paymentCbOrPxfInCartAfterAdd = result.cartInfo.total.is4xCbAvailable || result.cartInfo.total.isPxfAvailable;
                    this.cartPaymentChange = paymentCbOrPxfInCartBeforeAdd && !paymentCbOrPxfInCartAfterAdd;
                    this.paymentCbOrPxfInCart = paymentCbOrPxfInCartAfterAdd;
                    this.showAddedModal();
                })
                .catch((error) => {
                    if (error.status === 422) {
                        this.errorMessage = this.dto.cartMessages.maxArticleCountError;
                    } else if (error.status === 409) {
                        this.errorMessage = this.dto.cartMessages.alreadySameArticleInCartError;
                    } else if (error.status === 412) {
                        this.errorMessage = this.dto.cartMessages.outOfStockError;
                    } else {
                        this.errorMessage = this.dto.cartMessages.genericError;
                    }
                    this.state = DeviceAddedState.LOADED;
                    this.showErrorSnackBar();
                });
        },
        showAddedModal() {
            $('#add-to-cart-popin').modal('show');
        },
        getPriceWithoutPromo(version) {
            if (version.discountedPriceInCents === version.priceInCents) {
                return null
            }
            return version.priceInCents
        },
        getMoreDeviceReviews: function () {
            if (this.displayRatings) {
                this.deviceDetailsReviews.loading = true;
                this.fetchDeviceReviews().then(result => {
                    this.deviceDetailsReviews.cursor = result.nextCursor;
                    this.deviceDetailsReviews.reviews = this.deviceDetailsReviews.reviews.concat(result.reviews);
                    this.deviceDetailsReviews.loading = false;
                });
            }
        },
        updateDeviceDetailsReviews: function () {
            if (this.displayRatings) {
                this.deviceDetailsReviews.loading = true;
                this.fetchDeviceReviews().then(result => {
                    this.deviceDetailsReviews.cursor = result.nextCursor;
                    this.deviceDetailsReviews.reviews = result.reviews;
                    this.deviceDetailsReviews.loading = false;
                });
            }
        },
        loadDeviceReviews: function () {
            if (this.displayRatings) {
                this.selectedRatingsFilter = [];
                this.deviceDetailsReviews.loading = true;
                this.deviceFilterReviews.loading = true;
                this.fetchDeviceReviews().then(result => {
                    this.deviceDetailsReviews.cursor = result.nextCursor;
                    this.deviceDetailsReviews.reviews = result.reviews;
                    this.deviceFilterReviews.ratingsFilter = result.ratingsFilter;
                    this.updateSummaries(result);
                    this.deviceDetailsReviews.loading = false;
                    this.deviceFilterReviews.loading = false;
                });
            }
        },
        updateSummaries(result) {
            const summariesByEan = result?.summaries || {}
            const updatedAllVersions = (this.allVersions).map((version) => {
                const ean = version?.ean;
                const summary = ean ? summariesByEan[ean] : undefined;

                if (summary) {
                    // Ajoute/écrase une propriété "summary" sur la version
                    return {
                        ...version,
                        summary
                    };
                } else return version;
            });

            // Remplace la collection (pour assurer la réactivité)
            this.allVersions = updatedAllVersions;

            // Pareil, on écrase la currentVersion si on récupère le résumé sur la décli liée à l'url
            const currentSeoId = this.currentVersion?.seoId;
            if (currentSeoId) {
                const refreshedCurrent = updatedAllVersions.find(it => it?.seoId === currentSeoId);
                if (refreshedCurrent) this.currentVersion = refreshedCurrent;
            }
        },
        fetchDeviceReviews: function () {
            let url = "/api/mobile/accessory-reviews"
            return new Promise((resolve) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": "ORANGE",
                        "eans": this.allVersions.map(it => it.ean),
                        "first-party": this.currentVersion.firstParty,
                        "cursor": this.deviceDetailsReviews.cursor,
                        "ratings-input-filter": this.selectedRatingsFilter.toString(),
                        "reviewSort": this.reviewDateSortParam,
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    traditional: true, // pour éviter que jquery rename le paramètre eans -> eans[]
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail((error) => {
                    resolve(error.responseJSON)
                });
            });
        },
        updateRatingsFilterHandler(selectedRatingsFilter) {
            this.selectedRatingsFilter = selectedRatingsFilter;
            this.deviceDetailsReviews.cursor = null;
            this.updateDeviceDetailsReviews()
        },
        reviewDateSortHandler(sortValue) {
            this.reviewDateSortParam = sortValue;
            this.deviceDetailsReviews.cursor = null;
            this.updateDeviceDetailsReviews();
            this.updateUrlWithReviewsSort();
        },
        loadCrossSell: function () {
            return new Promise((resolve, reject) => {
                this.loadingCrossSell = true;
                this.fetchCrossSell().then(result => {
                    this.loadingCrossSell = false;
                    resolve(result);
                }).catch(() => {
                    this.loadingCrossSell = false;
                    reject();
                });
            })
        },
        fetchCrossSell() {
            let url = "/api/mobile/cross-sell/accessories"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "seoId": this.currentVersion.seoId
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                }).done(data => {
                    resolve(data);
                }).fail(error => {
                    reject(error);
                });
            });
        },
        getAccessoriesInCart(cart){
            let sum = 0;
            cart.accessories.forEach(item => {
                sum += item.quantity;
            });
            return sum;
        },
        onCrossSellUpdated(result){
            this.accessoriesInCartCount = this.getAccessoriesInCart(result.cartInfo);
            this.cartUrl = result.cartUrl;
        },
        onCrossSellError(error) {
            if (error.status === 422) {
                this.errorMessage = this.dto.cartMessages.maxArticleCountError;
            } else if (error.status === 409) {
                this.errorMessage = this.dto.cartMessages.alreadySameArticleInCartError;
            } else if (error.status === 412) {
                this.errorMessage = this.dto.cartMessages.outOfStockError;
            } else {
                this.errorMessage = this.dto.cartMessages.genericError;
            }
            this.showErrorSnackBar();
        },
        showErrorSnackBar() {
            const snackbar = this.$refs.snackbar;
            if (snackbar) {
                snackbar.show();
            }
        },
        scrollToPageMenuAnchor: function (id) {
            const element = document.getElementById(id);
            if (element) {
                // on ajoute 2px pour trigger l'événement de changement d'onglet et que le bon soit indiqué comme actif
                scrollToElement(element, {dx: 0, dy: -this.pageMenuOffsetHeight + 2});
            }
        },
        updateBreadcrumbFromReferrer() {
            if (!document.referrer) return;

            //Si le referer n'est pas valide alors on fait rien on garde le breadcrumbItems du back
            let referrerUrl;
            try {
                referrerUrl = new URL(document.referrer);
            } catch {
                return;
            }

            //Si le referer n'est pas dans le domaine boutique orange alors on fait rien on garde le breadcrumbItems du back
            if (referrerUrl.origin !== window.location.origin) return;

            //Si le referer ne commence pas par le mapping /tech-et-accessoires alors on fait rien on garde le breadcrumbItems du back
            const basePath = '/tech-et-accessoires';
            if (!referrerUrl.pathname.startsWith(basePath)) return;


            const segments = referrerUrl.pathname
                .replace(basePath, '')
                .split('/')
                .filter(s => s.length > 0);

            if (segments.length === 0) return;

            // On ignore le referer venant de la page de recherche /search/{textSearch}
            if (segments[0] === 'search') return;

            const intermediateItems = segments.map((segment, index) => {
                const department = this.departments.find(d => d.seoId === segment)
                return {
                    name: department ? department.label : segment.replace(/-/g, ' ').replace(/^\w/, c => c.toUpperCase()),
                    url: referrerUrl.origin + basePath + '/' + segments.slice(0, index + 1).join('/')
                }
            })

            //On garde Boutique Orange, Tech et Accessoires et le nom du produit du back
            const first = this.breadcrumbItems[0];
            const second = this.breadcrumbItems[1];
            const last = this.breadcrumbItems[this.breadcrumbItems.length - 1];
            this.breadcrumbItems = [first, second, ...intermediateItems, last];
        },
        getGradePopinAction() {
            const grade = this.currentVersion.grade;
            return grade ? `voir_${toTmsFormat(grade.label)}` : "";
        },
        updateRecoveryPrice(priceInCents, model) {
            this.estimatedDevice.recoveryPriceInCents = priceInCents;
            this.estimatedDevice.model = model;
            $("#" + this.simulatorModalId).modal('hide');
            $("#" + this.currentSimulationResultModalId).modal('show');
        },
        newSimulation() {
            $("#" + this.savedSimulationResultModalId).modal('hide');
            $("#" + this.currentSimulationResultModalId).modal('hide');
            $("#" + this.simulatorModalId).modal('show');
        },
        saveSimulation() {
            this.loadDeviceDetails();
            this.showSavedSimulationSnackbar();
        },
        showSavedSimulationSnackbar() {
            const snackbar = this.$refs.savedSimulationSnackbar;
            if (snackbar) {
                snackbar.show();
            }
        },
        fetchDeviceDetails: function () {
            let url = '/api/marketplace/device';
            url = addParam(url, 'shop=' + this.dto.shop);
            url = addParam(url, 'device=' + this.currentVersion.seoId);
            url = addParam(url, 'intention=' + 'terminal-seul');

            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            });
        },
        loadDeviceDetails: function () {
            return new Promise((resolve, reject) => {
                this.fetchDeviceDetails().then(result => {
                    const detailsBySeoId = result.detailsBySeoId || {};

                    this.allVersions = this.allVersions.map(version => ({
                        ...version,
                        ...(detailsBySeoId[version.seoId] || {})
                    }));

                    const refreshedVersion = this.allVersions.find(
                        version => version.seoId === this.currentVersion.seoId
                    );

                    if (refreshedVersion) {
                        this.currentVersion = refreshedVersion;
                    }
                    resolve();
                }).catch((error) => {
                    reject(error);
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.header {
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        align-items: flex-end;
    }
}

.info-device-width {
    width: 100%;
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 46%;
    }
}

.border-right-md {
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        border-right: px-to-rem(30) solid;
    }
}

.sticky {
    position: sticky;
    top: 0;
    z-index: 3;
}

.breadcrumb-full ::v-deep .breadcrumb {
    max-width: 100%;
}
</style>
